import { useMutation } from "@tanstack/react-query";
import { useNotificationStore } from "@src/shared/components/Notification";
import { cancelStructuredVacancy } from "@src/entities/requestHH/api/requests/cancelStructuredVacancy";
import { AxiosError } from "axios";

export const useCancelStructuredVacancy = () => {
  const { showAlert } = useNotificationStore();

  return useMutation({
    mutationFn: cancelStructuredVacancy,
    onError: (error: AxiosError) => {
      const response = error?.response?.data as {
        detail: { message: string; error: string };
      };
      const errorMessage = response?.detail.error || "";

      if (errorMessage.includes("not_enough_attempts")) {
        showAlert(response?.detail.message, "error");
        return;
      }
      if (errorMessage.includes("license_expired")) {
        showAlert(response?.detail.message, "error");
        return;
      }
      showAlert(error.message, "error");
    },
  });
};
